exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.q-and-a-container[data-v-64ad4cd6] {\n  max-width: 720px;\n  width: 100%;\n  margin: auto;\n}\n.q-and-a-container .question-wrapper[data-v-64ad4cd6] {\n    margin-top: 32px;\n}\n.q-and-a-container .answer-wrapper[data-v-64ad4cd6] {\n    margin-top: 24px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-64ad4cd6","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/LP/molecules/InterviewQAndA.vue
// module id = PFWl
// module chunks = 3